var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D4BFD7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.95 34C30.8 34 28.7043 33.5207 26.663 32.562C24.621 31.604 22.8127 30.3373 21.238 28.762C19.6627 27.1873 18.396 25.379 17.438 23.337C16.4793 21.2957 16 19.2 16 17.05C16 16.75 16.1 16.5 16.3 16.3C16.5 16.1 16.75 16 17.05 16H21.1C21.3333 16 21.5417 16.075 21.725 16.225C21.9083 16.375 22.0167 16.5667 22.05 16.8L22.7 20.3C22.7333 20.5333 22.7293 20.7457 22.688 20.937C22.646 21.129 22.55 21.3 22.4 21.45L20 23.9C20.7 25.1 21.575 26.225 22.625 27.275C23.675 28.325 24.8333 29.2333 26.1 30L28.45 27.65C28.6 27.5 28.796 27.3873 29.038 27.312C29.2793 27.2373 29.5167 27.2167 29.75 27.25L33.2 27.95C33.4333 28 33.625 28.1123 33.775 28.287C33.925 28.4623 34 28.6667 34 28.9V32.95C34 33.25 33.9 33.5 33.7 33.7C33.5 33.9 33.25 34 32.95 34Z",
    fill: "#D4BFD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.651e41f83baa1ae36e1e65dfd9bd55de.svg";
export { ForwardRef as ReactComponent };